module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (71).87a76f29.jpg";